// src/pages/NotFound.jsx
// @ts-nocheck
import React from "react";

const colors = {
  bgTop: "#0b1830",
  bgBottom: "#2b155e",
  primary: "#19E6FF",
  cardBorder: "rgba(255,255,255,0.08)",
};

export default function NotFound() {
  return (
    <div
      className="min-h-screen flex items-center justify-center px-6 text-white text-center"
      style={{
        background: `linear-gradient(${colors.bgTop}, ${colors.bgBottom})`,
      }}
    >
      <div className="max-w-lg">
        <div
          className="inline-flex items-center justify-center w-14 h-14 rounded-2xl border"
          style={{ borderColor: colors.cardBorder, background: "rgba(255,255,255,0.06)" }}
          aria-hidden="true"
        >
          <span className="text-2xl">🧭</span>
        </div>

        <h1 className="mt-5 text-3xl md:text-4xl font-extrabold">Η σελίδα δεν βρέθηκε</h1>
        <p className="mt-3 opacity-80">
          Το URL που ζητήσατε δεν υπάρχει. Επιστρέψτε στην αρχική για να συνεχίσετε.
        </p>

        <a
          href="/"
          className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-2xl font-medium"
          style={{ background: colors.primary, color: "#001018" }}
        >
          Επιστροφή στην Αρχική
        </a>
      </div>
    </div>
  );
}
